// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageDocContainer_hWtwg {
  position: fixed;
  background: white;
  border-radius: 6px;
  box-shadow: 0 20px 40px -20px rgba(0, 0, 0, 0.15);
  /* border: 1px solid #f8f8f8; */
  display: flex;
  flex-direction: column;
  z-index: 9999;
  min-width: 300px;
  min-height: 200px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.messageDocContainer_hWtwg:hover {
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
}

.messageDocContainer_hWtwg.minimized_a1B9t {
  width: 400px;
  height: 300px;
}

.messageDocContainer_hWtwg.expanded_Y9FvB {
  width: 800px;
  height: 600px;
}

.messageDocContainer_hWtwg.fullscreen_RJNtM {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  border-radius: 8px;
}

.header_GYEvt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background: linear-gradient(135deg, #157e64 0%, #10a37f 100%);
  background-size: 200% 200%;
  color: white;
  border-radius: -2px 12px 0 0;
  cursor: move;
  flex-shrink: 0;
  animation: gradientShift_A4SuI 3s ease-in-out infinite;
  position: relative;
  overflow: hidden;
}

.header_GYEvt::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shimmer_HtiEO 2s infinite;
}

@keyframes gradientShift_A4SuI {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

@keyframes shimmer_HtiEO {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.fullscreen_RJNtM .header_GYEvt {
  border-radius: 8px 8px 0 0;
}

.title_o3m36 {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.controls_yIRez {
  display: flex;
  gap: 8px;
  align-items: center;
}

.controlButton_f9p6L {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  color: white;
}

.controlButton_f9p6L:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.controlButton_f9p6L:active {
  transform: scale(0.95);
}

/* Editor Toolbar */
.editorToolbar_7KOqt {
  background: var(--f5-background);
  display: flex;
  gap: 2px;
  padding: 6px 4px;
  flex-shrink: 0;
  align-items: center;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.toolbarGroup_jt3tA {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0 10px;
  border-right: 1px solid #dee2e6;
}

.toolbarGroup_jt3tA:last-child {
  border-right: none;
}

.toolbarButton_QH7Qn {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #495057;
  font-weight: bold;
}

.toolbarButton_QH7Qn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.toolbarButton_QH7Qn.active_tRtVY {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.toolbarButton_QH7Qn.active_tRtVY:hover {
  background: #0056b3;
  border-color: #0056b3;
}

.toolbarSelect_lP2eK {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 7px 8px;
  font-size: 16px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  min-width: 80px;
}

.toolbarSelect_lP2eK:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Color Picker */
.colorPicker_ItthP {
  position: absolute;
  top: 80px;
  left: 20px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.colorButton_vC7Dk {
  width: 24px;
  height: 24px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.colorButton_vC7Dk:hover {
  transform: scale(1.1);
  border-color: #007bff;
}

/* Emoji Picker */
.emojiPicker_PLbMC {
  position: absolute;
  top: 80px;
  left: 20px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  /* grid-template-columns: repeat(10, 1fr); */
  gap: 4px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 285px;
}

.emojiButton_lgzFT {
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.emojiButton_lgzFT:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

/* Dialogs */
.dialogOverlay_TgJ1a {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.dialog_ZIgws {
  background: white;
  border-radius: 8px;
  padding: 24px;
  min-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.dialog_ZIgws h3 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 18px;
}

.dialogInput_FPInT {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 16px;
}

.dialogInput_FPInT:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.dialogButtons_xWwXv {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.dialogButton_vWs7_ {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: white;
  color: #495057;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.dialogButton_vWs7_:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.dialogButton_vWs7_:first-child {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.dialogButton_vWs7_:first-child:hover {
  background: #0056b3;
  border-color: #0056b3;
}

.content_Aymtl {
  flex: 1 1;
  overflow: hidden;
  position: relative;
  /* background: #f8f9fa; */
  background: var(--f5-background);
  -webkit-user-select: text;
          user-select: text;
}

/* Editor */
.editor_ROA12 {
  width: calc(100% - 20px);
  height: 100%;
  overflow: auto;
  padding: 0px 10px;
  outline: none;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  position: relative;
  z-index: 1;

  &::-webkit-scrollbar {
    display: none;
  }
}

/* .editor:focus {
  background: #fff;
} */

.editor_ROA12 h1,
.editor_ROA12 h2,
.editor_ROA12 h3,
.editor_ROA12 h4,
.editor_ROA12 h5,
.editor_ROA12 h6 {
  margin: 16px 0 8px 0;
  color: #333;
  font-weight: bold;
}

.editor_ROA12 h1 {
  font-size: 24px;
}

.editor_ROA12 h2 {
  font-size: 20px;
}

.editor_ROA12 h3 {
  font-size: 18px;
}

.editor_ROA12 h4 {
  font-size: 16px;
}

.editor_ROA12 h5 {
  font-size: 14px;
}

.editor_ROA12 h6 {
  font-size: 12px;
}

.editor_ROA12 p {
  margin: 8px 0;
}

.editor_ROA12 ul,
.editor_ROA12 ol {
  margin: 8px 0;
  padding-left: 24px;
}

.editor_ROA12 li {
  margin: 4px 0;
}

.editor_ROA12 blockquote {
  margin: 16px 0;
  padding: 12px 16px;
  border-left: 4px solid #007bff;
  background: #f8f9fa;
  font-style: italic;
  color: #666;
}

.editor_ROA12 code {
  background: #f1f3f4;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.editor_ROA12 pre {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 16px 0;
}

.editor_ROA12 pre code {
  background: none;
  padding: 0;
}

.editor_ROA12 table {
  border-collapse: collapse;
  width: 100%;
  margin: 16px 0;
}

.editor_ROA12 th,
.editor_ROA12 td {
  border: 1px solid #dee2e6;
  padding: 8px 12px;
  text-align: left;
}

.editor_ROA12 th {
  background: #f8f9fa;
  font-weight: bold;
}

.editor_ROA12 img {
  max-width: 100%;
  height: auto;
  margin: 8px 0;
}

.editor_ROA12 a {
  color: #007bff;
  text-decoration: none;
}

.editor_ROA12 a:hover {
  text-decoration: underline;
}

.htmlContent_U2abp {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* padding: 20px; */
  background: white;
  /* border-radius: 0 0 12px 12px; */
}

.fullscreen_RJNtM .htmlContent_U2abp {
  border-radius: 0 0 8px 8px;
}

.htmlContent_U2abp .empty-state_LYwiV {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;
  font-style: italic;
  font-size: 16px;
}

/* Resize handles */
.resizeHandle_B0O3I {
  position: absolute;
  background: transparent;
  z-index: 10;
}

.resizeTop_nPKEf {
  top: 0;
  left: 0;
  width: 100%;
  height: 8px;
  cursor: ns-resize;
}

.resizeLeft_iYQzQ {
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
  cursor: ew-resize;
}

.resizeRight_ngfc_ {
  right: 0;
  top: 0;
  width: 8px;
  height: 100%;
  cursor: ew-resize;
}

.resizeBottom_xEqnm {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 8px;
  cursor: ns-resize;
}

.resizeCorner_WzUD2 {
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  cursor: nw-resize;
}

.resizeTopLeft_PAjRd {
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  cursor: nw-resize;
}

.resizeTopRight_c8c4I {
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  cursor: ne-resize;
}

.resizeBottomLeft_CTGrz {
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  cursor: ne-resize;
}

.resizeHandle_B0O3I:hover::after {
  content: '';
  position: absolute;
  background: rgba(102, 126, 234, 0.3);
  border-radius: 2px;
}

.resizeTop_nPKEf:hover::after {
  top: 2px;
  left: 0;
  width: 100%;
  height: 4px;
}

.resizeLeft_iYQzQ:hover::after {
  left: 2px;
  top: 0;
  width: 4px;
  height: 100%;
}

.resizeRight_ngfc_:hover::after {
  right: 2px;
  top: 0;
  width: 4px;
  height: 100%;
}

.resizeBottom_xEqnm:hover::after {
  bottom: 2px;
  left: 0;
  width: 100%;
  height: 4px;
}

.resizeCorner_WzUD2:hover::after {
  right: 2px;
  bottom: 2px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.resizeTopLeft_PAjRd:hover::after {
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.resizeTopRight_c8c4I:hover::after {
  top: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.resizeBottomLeft_CTGrz:hover::after {
  bottom: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .messageDocContainer_hWtwg {
    width: calc(100vw - 20px) !important;
    height: calc(100vh - 20px) !important;
    left: 10px !important;
    top: 10px !important;
  }

  .messageDocContainer_hWtwg .header_GYEvt {
    padding: 8px 12px;
  }

  .messageDocContainer_hWtwg .htmlContent_U2abp {
    padding: 12px;
  }

  .controls_yIRez {
    gap: 4px;
  }

  .controlButton_f9p6L {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }

  .editorToolbar_7KOqt {
    flex-direction: column;
    gap: 4px;
    padding: 4px 8px;
  }

  .toolbarGroup_jt3tA {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 4px;
  }

  .toolbarGroup_jt3tA:last-child {
    border-bottom: none;
  }

  .toolbarButton_QH7Qn {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .toolbarSelect_lP2eK {
    min-width: 60px;
    font-size: 11px;
  }

  .emojiPicker_PLbMC {
    grid-template-columns: repeat(8, 1fr);
    max-width: 240px;
  }

  .colorPicker_ItthP {
    grid-template-columns: repeat(6, 1fr);
  }

  .dialog_ZIgws {
    min-width: 300px;
    margin: 20px;
  }
}

.messageDocContainer_hWtwg {
  animation: slideIn_ffrDZ 0.3s ease-out;
}

@keyframes slideIn_ffrDZ {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.htmlContent_U2abp::-webkit-scrollbar {
  width: 8px;
}

.htmlContent_U2abp::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.htmlContent_U2abp::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.htmlContent_U2abp::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.editor_ROA12::-webkit-scrollbar {
  width: 8px;
}

.editor_ROA12::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.editor_ROA12::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.editor_ROA12::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Estilos para secciones seleccionadas */
.editor_ROA12 section {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  padding-left: 8px;
  margin: 4px 0;
}

.editor_ROA12 section:hover {
  background-color: rgba(22, 192, 152, 0.05);
  border-left-color: rgba(22, 192, 152, 0.3);
}

.editor_ROA12 section.selected_VchBo {
  background-color: rgba(22, 192, 152, 0.1);
  border-left-color: #16c098;
  box-shadow: 0 2px 8px rgba(22, 192, 152, 0.2);
}

.editor_ROA12 section.selected_VchBo::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #16c098 0%, #10a37f 100%);
  border-radius: 2px;
  animation: sectionGlow_Eo6CB 2s ease-in-out infinite alternate;
}

@keyframes sectionGlow_Eo6CB {
  0% {
    box-shadow: 0 0 5px rgba(22, 192, 152, 0.5);
  }

  100% {
    box-shadow: 0 0 15px rgba(22, 192, 152, 0.8);
  }
}

@keyframes sectionClick_auwLn {
  0% {
    transform: translateX(4px) scale(1);
  }

  50% {
    transform: translateX(4px) scale(1.02);
  }

  100% {
    transform: translateX(4px) scale(1);
  }
}

.editor_ROA12 section.sectionClicked_TepqB {
  animation: sectionClick_auwLn 0.3s ease-out;
}

/* Estilos para el indicador de sección seleccionada */
.sectionIndicator_qJvJK {
  background: var(--f5-background);
  color: var(--1e293b-color);
  padding: 4px 2px;
  font-size: 12px;
  font-weight: 500;
  z-index: 9;
  /* box-shadow: 0 6px 20px rgba(22, 192, 152, 0.4); */
  opacity: 0;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: sticky;
  bottom: 0px;
  display: inline-flex;
}

.sectionIndicator_qJvJK.show_yWYA6 {
  opacity: 1;
  /* transform: translateY(-50%) scale(1); */
}

.sectionInfo_am61J {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.sectionId_XPWiK {
  font-size: 14px;
  opacity: 0.9;
}

.sectionActions_Nn1eg {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.sectionActionBtn_laW0N {
  background: var(--white-background);
  border: none;
  border-radius: 6px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 10px;
  color: var(--black-color);
  font-weight: bold;
}

.sectionActionBtn_laW0N:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.sectionActionBtn_laW0N:active {
  transform: scale(0.95);
}

/* Estilos para el tooltip de sección */
.sectionTooltip_Nq7oq {
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  z-index: 1001;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.sectionTooltip_Nq7oq.show_yWYA6 {
  opacity: 1;
}

/* Mejoras en la interactividad de las secciones */
.editor_ROA12 section {
  -webkit-user-select: text;
          user-select: text;
}

.editor_ROA12 section:focus-within {
  outline: 2px solid rgba(22, 192, 152, 0.5);
  outline-offset: 2px;
}

.editor_ROA12 [class^="page"] {
  padding: 0px;
}

/* Estilos para secciones anidadas */
/* .editor section section {
  margin-left: 16px;
  border-left-width: 2px;
} */

.editor_ROA12 section section.selected_VchBo {
  border-left-color: #10a37f;
}

/* Estilos para diferentes tipos de contenido */
.editor_ROA12 section h1,
.editor_ROA12 section h2,
.editor_ROA12 section h3,
.editor_ROA12 section h4,
.editor_ROA12 section h5,
.editor_ROA12 section h6 {
  margin: 0;
  padding: 4px 0;
}

.editor_ROA12 section p {
  margin: 4px 0;
}

.editor_ROA12 section ul,
.editor_ROA12 section ol {
  margin: 4px 0;
  padding-left: 20px;
}

.editor_ROA12 section table {
  margin: 8px 0;
  border-collapse: collapse;
  width: 100%;
}

.editor_ROA12 section table th,
.editor_ROA12 section table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.editor_ROA12 section table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

/* Estilos para el modo de edición */
.editor_ROA12.editing_iC7MO section {
  cursor: text;
}

.editor_ROA12.editing_iC7MO section:hover {
  background-color: rgba(22, 192, 152, 0.02);
}

.editor_ROA12.editing_iC7MO section.selected_VchBo {
  background-color: rgba(22, 192, 152, 0.05);
}

/* Estilos para el modo de visualización */
.editor_ROA12.viewing_NnvT_ section {
  cursor: pointer;
}

.editor_ROA12.viewing_NnvT_ section:hover {
  background-color: rgba(22, 192, 152, 0.08);
}

.editor_ROA12.viewing_NnvT_ section.selected_VchBo {
  background-color: rgba(22, 192, 152, 0.15);
}

/* Animaciones adicionales */
.editor_ROA12 section {
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.editor_ROA12 section.selected_VchBo {
  /* transform: translateX(4px); */
}

.editor_ROA12 section:hover {
  transform: translateX(2px);
}

/* Estilos para el estado de carga */
.editor_ROA12 section.loading_l2iXG {
  opacity: 0.7;
  pointer-events: none;
}

.editor_ROA12 section.loading_l2iXG::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid #16c098;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin_oZNip 1s linear infinite;
}

@keyframes spin_oZNip {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Estilos para el modo oscuro */
@media (prefers-color-scheme: dark) {
  .editor_ROA12 section {
    border-left-color: rgba(22, 192, 152, 0.2);
  }

  .editor_ROA12 section:hover {
    background-color: rgba(22, 192, 152, 0.1);
  }

  .editor_ROA12 section.selected_VchBo {
    background-color: rgba(22, 192, 152, 0.2);
  }

  .sectionIndicator_qJvJK {
    background: rgba(22, 192, 152, 0.95);
  }
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .editor_ROA12 section {
    padding-left: 4px;
    margin: 2px 0;
  }

  .editor_ROA12 section section {
    margin-left: 8px;
  }

  .sectionIndicator_qJvJK {
    right: 10px;
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* Estilos para el modo de impresión */
@media print {
  .editor_ROA12 section {
    border-left: none;
    background: none;
    box-shadow: none;
  }

  .editor_ROA12 section.selected_VchBo {
    background: none;
    border-left: 2px solid #16c098;
  }

  .sectionIndicator_qJvJK,
  .sectionTooltip_Nq7oq {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/MessageDoc/MessageDoc.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,sDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,oCAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,QAAQ;EACR,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;;EAEV;IACE,aAAa;EACf;AACF;;AAEA;;GAEG;;AAEH;;;;;;EAME,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,SAAS;EACT,MAAM;EACN,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,MAAM;EACN,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,oCAAoC;IACpC,qCAAqC;IACrC,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,sCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,6DAA6D;EAC7D,kBAAkB;EAClB,8DAAwD;AAC1D;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,2CAAqC;AACvC;;AAEA,sDAAsD;AACtD;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oDAAoD;EACpD,UAAU;EACV,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;;;GAGG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;;;;;;EAME,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,wCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".messageDocContainer {\n  position: fixed;\n  background: white;\n  border-radius: 6px;\n  box-shadow: 0 20px 40px -20px rgba(0, 0, 0, 0.15);\n  /* border: 1px solid #f8f8f8; */\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n  min-width: 300px;\n  min-height: 200px;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.messageDocContainer:hover {\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);\n}\n\n.messageDocContainer.minimized {\n  width: 400px;\n  height: 300px;\n}\n\n.messageDocContainer.expanded {\n  width: 800px;\n  height: 600px;\n}\n\n.messageDocContainer.fullscreen {\n  width: calc(100vw - 40px);\n  height: calc(100vh - 40px);\n  border-radius: 8px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 8px;\n  background: linear-gradient(135deg, #157e64 0%, #10a37f 100%);\n  background-size: 200% 200%;\n  color: white;\n  border-radius: -2px 12px 0 0;\n  cursor: move;\n  flex-shrink: 0;\n  animation: gradientShift 3s ease-in-out infinite;\n  position: relative;\n  overflow: hidden;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes gradientShift {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n\n  100% {\n    left: 100%;\n  }\n}\n\n.fullscreen .header {\n  border-radius: 8px 8px 0 0;\n}\n\n.title {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n}\n\n.controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.controlButton {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 6px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 12px;\n  color: white;\n}\n\n.controlButton:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.controlButton:active {\n  transform: scale(0.95);\n}\n\n/* Editor Toolbar */\n.editorToolbar {\n  background: var(--f5-background);\n  display: flex;\n  gap: 2px;\n  padding: 6px 4px;\n  flex-shrink: 0;\n  align-items: center;\n  overflow-x: scroll;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.toolbarGroup {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  padding: 0 10px;\n  border-right: 1px solid #dee2e6;\n}\n\n.toolbarGroup:last-child {\n  border-right: none;\n}\n\n.toolbarButton {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #495057;\n  font-weight: bold;\n}\n\n.toolbarButton:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.toolbarButton.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.toolbarButton.active:hover {\n  background: #0056b3;\n  border-color: #0056b3;\n}\n\n.toolbarSelect {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 7px 8px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n  min-width: 80px;\n}\n\n.toolbarSelect:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Color Picker */\n.colorPicker {\n  position: absolute;\n  top: 80px;\n  left: 20px;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 8px;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.colorButton {\n  width: 24px;\n  height: 24px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.colorButton:hover {\n  transform: scale(1.1);\n  border-color: #007bff;\n}\n\n/* Emoji Picker */\n.emojiPicker {\n  position: absolute;\n  top: 80px;\n  left: 20px;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  /* grid-template-columns: repeat(10, 1fr); */\n  gap: 4px;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 285px;\n}\n\n.emojiButton {\n  width: 28px;\n  height: 28px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.emojiButton:hover {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n/* Dialogs */\n.dialogOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.dialog {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  min-width: 400px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.dialog h3 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.dialogInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.dialogInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.dialogButtons {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.dialogButton {\n  padding: 8px 16px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: white;\n  color: #495057;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.dialogButton:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.dialogButton:first-child {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.dialogButton:first-child:hover {\n  background: #0056b3;\n  border-color: #0056b3;\n}\n\n.content {\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  /* background: #f8f9fa; */\n  background: var(--f5-background);\n  user-select: text;\n}\n\n/* Editor */\n.editor {\n  width: calc(100% - 20px);\n  height: 100%;\n  overflow: auto;\n  padding: 0px 10px;\n  outline: none;\n  font-family: 'Arial', sans-serif;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n  position: relative;\n  z-index: 1;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/* .editor:focus {\n  background: #fff;\n} */\n\n.editor h1,\n.editor h2,\n.editor h3,\n.editor h4,\n.editor h5,\n.editor h6 {\n  margin: 16px 0 8px 0;\n  color: #333;\n  font-weight: bold;\n}\n\n.editor h1 {\n  font-size: 24px;\n}\n\n.editor h2 {\n  font-size: 20px;\n}\n\n.editor h3 {\n  font-size: 18px;\n}\n\n.editor h4 {\n  font-size: 16px;\n}\n\n.editor h5 {\n  font-size: 14px;\n}\n\n.editor h6 {\n  font-size: 12px;\n}\n\n.editor p {\n  margin: 8px 0;\n}\n\n.editor ul,\n.editor ol {\n  margin: 8px 0;\n  padding-left: 24px;\n}\n\n.editor li {\n  margin: 4px 0;\n}\n\n.editor blockquote {\n  margin: 16px 0;\n  padding: 12px 16px;\n  border-left: 4px solid #007bff;\n  background: #f8f9fa;\n  font-style: italic;\n  color: #666;\n}\n\n.editor code {\n  background: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n}\n\n.editor pre {\n  background: #f8f9fa;\n  padding: 12px;\n  border-radius: 4px;\n  overflow-x: auto;\n  margin: 16px 0;\n}\n\n.editor pre code {\n  background: none;\n  padding: 0;\n}\n\n.editor table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 16px 0;\n}\n\n.editor th,\n.editor td {\n  border: 1px solid #dee2e6;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.editor th {\n  background: #f8f9fa;\n  font-weight: bold;\n}\n\n.editor img {\n  max-width: 100%;\n  height: auto;\n  margin: 8px 0;\n}\n\n.editor a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.editor a:hover {\n  text-decoration: underline;\n}\n\n.htmlContent {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  /* padding: 20px; */\n  background: white;\n  /* border-radius: 0 0 12px 12px; */\n}\n\n.fullscreen .htmlContent {\n  border-radius: 0 0 8px 8px;\n}\n\n.htmlContent .empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #6c757d;\n  font-style: italic;\n  font-size: 16px;\n}\n\n/* Resize handles */\n.resizeHandle {\n  position: absolute;\n  background: transparent;\n  z-index: 10;\n}\n\n.resizeTop {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n  cursor: ns-resize;\n}\n\n.resizeLeft {\n  left: 0;\n  top: 0;\n  width: 8px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.resizeRight {\n  right: 0;\n  top: 0;\n  width: 8px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.resizeBottom {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n  cursor: ns-resize;\n}\n\n.resizeCorner {\n  right: 0;\n  bottom: 0;\n  width: 16px;\n  height: 16px;\n  cursor: nw-resize;\n}\n\n.resizeTopLeft {\n  top: 0;\n  left: 0;\n  width: 16px;\n  height: 16px;\n  cursor: nw-resize;\n}\n\n.resizeTopRight {\n  top: 0;\n  right: 0;\n  width: 16px;\n  height: 16px;\n  cursor: ne-resize;\n}\n\n.resizeBottomLeft {\n  bottom: 0;\n  left: 0;\n  width: 16px;\n  height: 16px;\n  cursor: ne-resize;\n}\n\n.resizeHandle:hover::after {\n  content: '';\n  position: absolute;\n  background: rgba(102, 126, 234, 0.3);\n  border-radius: 2px;\n}\n\n.resizeTop:hover::after {\n  top: 2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n}\n\n.resizeLeft:hover::after {\n  left: 2px;\n  top: 0;\n  width: 4px;\n  height: 100%;\n}\n\n.resizeRight:hover::after {\n  right: 2px;\n  top: 0;\n  width: 4px;\n  height: 100%;\n}\n\n.resizeBottom:hover::after {\n  bottom: 2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n}\n\n.resizeCorner:hover::after {\n  right: 2px;\n  bottom: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.resizeTopLeft:hover::after {\n  top: 2px;\n  left: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.resizeTopRight:hover::after {\n  top: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.resizeBottomLeft:hover::after {\n  bottom: 2px;\n  left: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .messageDocContainer {\n    width: calc(100vw - 20px) !important;\n    height: calc(100vh - 20px) !important;\n    left: 10px !important;\n    top: 10px !important;\n  }\n\n  .messageDocContainer .header {\n    padding: 8px 12px;\n  }\n\n  .messageDocContainer .htmlContent {\n    padding: 12px;\n  }\n\n  .controls {\n    gap: 4px;\n  }\n\n  .controlButton {\n    width: 24px;\n    height: 24px;\n    font-size: 10px;\n  }\n\n  .editorToolbar {\n    flex-direction: column;\n    gap: 4px;\n    padding: 4px 8px;\n  }\n\n  .toolbarGroup {\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n    padding-bottom: 4px;\n  }\n\n  .toolbarGroup:last-child {\n    border-bottom: none;\n  }\n\n  .toolbarButton {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .toolbarSelect {\n    min-width: 60px;\n    font-size: 11px;\n  }\n\n  .emojiPicker {\n    grid-template-columns: repeat(8, 1fr);\n    max-width: 240px;\n  }\n\n  .colorPicker {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  .dialog {\n    min-width: 300px;\n    margin: 20px;\n  }\n}\n\n.messageDocContainer {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.htmlContent::-webkit-scrollbar {\n  width: 8px;\n}\n\n.htmlContent::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.htmlContent::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.htmlContent::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.editor::-webkit-scrollbar {\n  width: 8px;\n}\n\n.editor::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.editor::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.editor::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Estilos para secciones seleccionadas */\n.editor section {\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-left: 4px solid transparent;\n  padding-left: 8px;\n  margin: 4px 0;\n}\n\n.editor section:hover {\n  background-color: rgba(22, 192, 152, 0.05);\n  border-left-color: rgba(22, 192, 152, 0.3);\n}\n\n.editor section.selected {\n  background-color: rgba(22, 192, 152, 0.1);\n  border-left-color: #16c098;\n  box-shadow: 0 2px 8px rgba(22, 192, 152, 0.2);\n}\n\n.editor section.selected::before {\n  content: '';\n  position: absolute;\n  left: -4px;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: linear-gradient(180deg, #16c098 0%, #10a37f 100%);\n  border-radius: 2px;\n  animation: sectionGlow 2s ease-in-out infinite alternate;\n}\n\n@keyframes sectionGlow {\n  0% {\n    box-shadow: 0 0 5px rgba(22, 192, 152, 0.5);\n  }\n\n  100% {\n    box-shadow: 0 0 15px rgba(22, 192, 152, 0.8);\n  }\n}\n\n@keyframes sectionClick {\n  0% {\n    transform: translateX(4px) scale(1);\n  }\n\n  50% {\n    transform: translateX(4px) scale(1.02);\n  }\n\n  100% {\n    transform: translateX(4px) scale(1);\n  }\n}\n\n.editor section.sectionClicked {\n  animation: sectionClick 0.3s ease-out;\n}\n\n/* Estilos para el indicador de sección seleccionada */\n.sectionIndicator {\n  background: var(--f5-background);\n  color: var(--1e293b-color);\n  padding: 4px 2px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 9;\n  /* box-shadow: 0 6px 20px rgba(22, 192, 152, 0.4); */\n  opacity: 0;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  position: sticky;\n  bottom: 0px;\n  display: inline-flex;\n}\n\n.sectionIndicator.show {\n  opacity: 1;\n  /* transform: translateY(-50%) scale(1); */\n}\n\n.sectionInfo {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.sectionId {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.sectionActions {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n}\n\n.sectionActionBtn {\n  background: var(--white-background);\n  border: none;\n  border-radius: 6px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 10px;\n  color: var(--black-color);\n  font-weight: bold;\n}\n\n.sectionActionBtn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.sectionActionBtn:active {\n  transform: scale(0.95);\n}\n\n/* Estilos para el tooltip de sección */\n.sectionTooltip {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  white-space: nowrap;\n  z-index: 1001;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.sectionTooltip.show {\n  opacity: 1;\n}\n\n/* Mejoras en la interactividad de las secciones */\n.editor section {\n  user-select: text;\n}\n\n.editor section:focus-within {\n  outline: 2px solid rgba(22, 192, 152, 0.5);\n  outline-offset: 2px;\n}\n\n.editor [class^=\"page\"] {\n  padding: 0px;\n}\n\n/* Estilos para secciones anidadas */\n/* .editor section section {\n  margin-left: 16px;\n  border-left-width: 2px;\n} */\n\n.editor section section.selected {\n  border-left-color: #10a37f;\n}\n\n/* Estilos para diferentes tipos de contenido */\n.editor section h1,\n.editor section h2,\n.editor section h3,\n.editor section h4,\n.editor section h5,\n.editor section h6 {\n  margin: 0;\n  padding: 4px 0;\n}\n\n.editor section p {\n  margin: 4px 0;\n}\n\n.editor section ul,\n.editor section ol {\n  margin: 4px 0;\n  padding-left: 20px;\n}\n\n.editor section table {\n  margin: 8px 0;\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.editor section table th,\n.editor section table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.editor section table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n}\n\n/* Estilos para el modo de edición */\n.editor.editing section {\n  cursor: text;\n}\n\n.editor.editing section:hover {\n  background-color: rgba(22, 192, 152, 0.02);\n}\n\n.editor.editing section.selected {\n  background-color: rgba(22, 192, 152, 0.05);\n}\n\n/* Estilos para el modo de visualización */\n.editor.viewing section {\n  cursor: pointer;\n}\n\n.editor.viewing section:hover {\n  background-color: rgba(22, 192, 152, 0.08);\n}\n\n.editor.viewing section.selected {\n  background-color: rgba(22, 192, 152, 0.15);\n}\n\n/* Animaciones adicionales */\n.editor section {\n  transform: translateX(0);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.editor section.selected {\n  /* transform: translateX(4px); */\n}\n\n.editor section:hover {\n  transform: translateX(2px);\n}\n\n/* Estilos para el estado de carga */\n.editor section.loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.editor section.loading::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 16px;\n  height: 16px;\n  margin: -8px 0 0 -8px;\n  border: 2px solid #16c098;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Estilos para el modo oscuro */\n@media (prefers-color-scheme: dark) {\n  .editor section {\n    border-left-color: rgba(22, 192, 152, 0.2);\n  }\n\n  .editor section:hover {\n    background-color: rgba(22, 192, 152, 0.1);\n  }\n\n  .editor section.selected {\n    background-color: rgba(22, 192, 152, 0.2);\n  }\n\n  .sectionIndicator {\n    background: rgba(22, 192, 152, 0.95);\n  }\n}\n\n/* Estilos responsivos */\n@media (max-width: 768px) {\n  .editor section {\n    padding-left: 4px;\n    margin: 2px 0;\n  }\n\n  .editor section section {\n    margin-left: 8px;\n  }\n\n  .sectionIndicator {\n    right: 10px;\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Estilos para el modo de impresión */\n@media print {\n  .editor section {\n    border-left: none;\n    background: none;\n    box-shadow: none;\n  }\n\n  .editor section.selected {\n    background: none;\n    border-left: 2px solid #16c098;\n  }\n\n  .sectionIndicator,\n  .sectionTooltip {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageDocContainer": `messageDocContainer_hWtwg`,
	"minimized": `minimized_a1B9t`,
	"expanded": `expanded_Y9FvB`,
	"fullscreen": `fullscreen_RJNtM`,
	"header": `header_GYEvt`,
	"gradientShift": `gradientShift_A4SuI`,
	"shimmer": `shimmer_HtiEO`,
	"title": `title_o3m36`,
	"controls": `controls_yIRez`,
	"controlButton": `controlButton_f9p6L`,
	"editorToolbar": `editorToolbar_7KOqt`,
	"toolbarGroup": `toolbarGroup_jt3tA`,
	"toolbarButton": `toolbarButton_QH7Qn`,
	"active": `active_tRtVY`,
	"toolbarSelect": `toolbarSelect_lP2eK`,
	"colorPicker": `colorPicker_ItthP`,
	"colorButton": `colorButton_vC7Dk`,
	"emojiPicker": `emojiPicker_PLbMC`,
	"emojiButton": `emojiButton_lgzFT`,
	"dialogOverlay": `dialogOverlay_TgJ1a`,
	"dialog": `dialog_ZIgws`,
	"dialogInput": `dialogInput_FPInT`,
	"dialogButtons": `dialogButtons_xWwXv`,
	"dialogButton": `dialogButton_vWs7_`,
	"content": `content_Aymtl`,
	"editor": `editor_ROA12`,
	"htmlContent": `htmlContent_U2abp`,
	"empty-state": `empty-state_LYwiV`,
	"resizeHandle": `resizeHandle_B0O3I`,
	"resizeTop": `resizeTop_nPKEf`,
	"resizeLeft": `resizeLeft_iYQzQ`,
	"resizeRight": `resizeRight_ngfc_`,
	"resizeBottom": `resizeBottom_xEqnm`,
	"resizeCorner": `resizeCorner_WzUD2`,
	"resizeTopLeft": `resizeTopLeft_PAjRd`,
	"resizeTopRight": `resizeTopRight_c8c4I`,
	"resizeBottomLeft": `resizeBottomLeft_CTGrz`,
	"slideIn": `slideIn_ffrDZ`,
	"selected": `selected_VchBo`,
	"sectionGlow": `sectionGlow_Eo6CB`,
	"sectionClicked": `sectionClicked_TepqB`,
	"sectionClick": `sectionClick_auwLn`,
	"sectionIndicator": `sectionIndicator_qJvJK`,
	"show": `show_yWYA6`,
	"sectionInfo": `sectionInfo_am61J`,
	"sectionId": `sectionId_XPWiK`,
	"sectionActions": `sectionActions_Nn1eg`,
	"sectionActionBtn": `sectionActionBtn_laW0N`,
	"sectionTooltip": `sectionTooltip_Nq7oq`,
	"editing": `editing_iC7MO`,
	"viewing": `viewing_NnvT_`,
	"loading": `loading_l2iXG`,
	"spin": `spin_oZNip`
};
export default ___CSS_LOADER_EXPORT___;
